import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";


export const getSmartConnectSettings = async () => {
    try {
        const token = getToken();
        const response = await apiService.get(`${API_URL.SMART_CONNECT}/fetch-configuration`, token);
        return response;
    } catch (err) {
        console.log("Error in getSmartConnectSettings service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const createSmartConnectSettings = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/create-configuration`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in createSmartConnectSettings service : ", err);
        return err?.response?.data || { success: false, message: "Internal Server Error", data: null };
    }
}

export const unAssignedAgentCurrentDid = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/unassignedCurrentDid`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in unAssignedAgentCurrentDid service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const saveSmartConnectSettings = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/save-configuration`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in saveSmartConnectSettings service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const getSmartConnectAgents = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/fetchAgents`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in saveSmartConnectSettings service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const updateAgent = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/updateAgent`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in updateAgent service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const bulkAddSmartConnectAgents = async (formData) => {
    try {
        const token = getToken();
        const response = await apiService.postWithFormData(`${API_URL.SMART_CONNECT_MANUAL}/uploadBulkAgents`, formData, token);
        return response;
    } catch (err) {
        console.log("Error in bulkAddSmartConnectAgents service : ", err);
        return err?.response?.data || { success: false, message: "Internal Server Error!!", data: null };
    }
}


export const addDIDs = async (formData) => {
    try {
        const token = getToken();
        const response = await apiService.postWithFormData(`${API_URL.SMART_CONNECT_MANUAL}/addDids`, formData, token);
        return response;
    } catch (err) {
        console.log("Error in addDIDs service : ", err);
        // Backend returns HTTP 400 with a meaningful message (e.g. duplicates);
        // surface that instead of a generic "Internal Server Error".
        return (
            err?.response?.data || {
                success: false,
                message: "Internal Server Error",
                data: null,
            }
        );
    }
}

export const fetchDIDs = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/fetchDids`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchDIDs service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const fetchDidsFromAgentAssignmentDid = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/fetchAssignedDids`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchDidsFromAgentAssignmentDid service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const viewAgentAssignedDids = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/fetchAgentAssignedDids`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in viewAgentAssignedDids service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const fetchSummary = async () => {
    try {
        const token = getToken();
        const response = await apiService.get(`${API_URL.SMART_CONNECT}/fetchSummary`, token);
        return response;
    } catch (err) {
        console.log("Error in fetchSummary service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const assignDidToCsmAgents = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/assignDidToCsmAgents`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchSummary service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const fetchSpammedDidList = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(`${API_URL.SMART_CONNECT}/fetchSpammedDids`, payload, token);
        return response;
    } catch (err) {
        console.log("Error in fetchSpammedDidList service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}